import React from 'react';
import { filtersData } from '../../constants/filtersData';
import { filterNames } from '../../constants/filterNames';
import { horizontalChartPlaceholderType } from '../../constants/common';

const getContent = (item) => {
  const num = item.rating / item.ratingCount;

  const val = isNaN(num) ? 'Нет оценок' : Math.floor(num * 10) / 10;

  return `${item.name} — ${val}`;
};

export const chartNames = {
  mark: 'mark',
  region: 'region',
  master: 'master',
  executer: 'executer',
  parentService: 'parentService',
  service: 'service',
  address: 'address',
};

export const pieCharts = [
  {
    area: chartNames.mark,
    title: `заявки по признакам`,
    filter: filtersData[filterNames.marks],
    marksChart: true,
  },
  {
    area: chartNames.region,
    title: `заявки по районам`,
    filter: filtersData[filterNames.regions],
  },
];

export const lifetimePieCharts = [
  {
    area: chartNames.mark,
    title: 'Оценки по заявкам',
    filter: filtersData[filterNames.ratings],
    renderContent: (item) => (
      <>
        {item.name} — {item.value} ({item.percent}%)
      </>
    ),
  },
  {
    area: chartNames.region,
    title: 'Средняя оценка по объектам',
    filter: filtersData[filterNames.regions],
    renderContent: (item) => getContent(item),
    valueKey: 'averageRating',
  },
];

export const horizontalCharts = [
  {
    area: chartNames.master,
    title: `заявки по мастерам`,
    filter: filtersData[filterNames.masters],
  },
  {
    area: chartNames.executer,
    title: `заявки по исполнителям`,
    filter: filtersData[filterNames.executers],
  },
  {
    area: chartNames.parentService,
    title: `заявки по услугам`,
    filter: filtersData[filterNames.parentServices],
    placeholderType: horizontalChartPlaceholderType.PARENT_SERVICE,
  },
  {
    area: chartNames.service,
    title: `заявки по причинам`,
    filter: filtersData[filterNames.services],
    placeholderType: horizontalChartPlaceholderType.SERVICE,
  },
  {
    area: chartNames.address,
    title: `заявки по адресам`,
    // filter: filtersData[filterNames.flats],
    filter: filtersData[filterNames.houses],
    placeholderType: horizontalChartPlaceholderType.ADDRESS,
  },
];

export const lifetineHorizontalCharts = [
  {
    area: chartNames.master,
    title: `Средняя оценка заявок по мастерам`,
    filter: filtersData[filterNames.masters],
    valueKey: 'averageRating',
    nullContent: 'Нет оценок',
  },
  {
    area: chartNames.executer,
    title: `Среднее время жизни заявок по мастерам`,
    filter: filtersData[filterNames.masters],
    valueKey: 'averageLifetime',
    nullContent: 'Нет выполненных заявок',
  },
  {
    area: chartNames.parentService,
    title: `Средняя оценка заявок по исполнителям`,
    filter: filtersData[filterNames.executers],
    valueKey: 'averageRating',
    nullContent: 'Нет оценок',
  },
  {
    area: chartNames.service,
    title: `Среднее время жизни заявок по исполнителям`,
    filter: filtersData[filterNames.executers],
    valueKey: 'averageLifetime',
    nullContent: 'Нет выполненных заявок',
  },
];
